module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "category-view"
  }, [_c('CategoryWrapper', {
    attrs: {
      "category-index": "1"
    }
  }, [_c('Category', {
    attrs: {
      "title": "Forms",
      "img": "https://imgly.net/img/2gj.jpg",
      "value": "0"
    }
  }, [_c('ListItem', {
    attrs: {
      "title": "带图标",
      "link": "category",
      "img": "https://imgly.net/img/2gj.jpg"
    }
  }), _vm._v(" "), _c('ListItem', {
    attrs: {
      "title": "带图标",
      "link": "category",
      "img": "https://imgly.net/img/2gj.jpg"
    }
  }), _vm._v(" "), _c('ListItem', {
    attrs: {
      "title": "带图标",
      "link": "category",
      "img": "https://imgly.net/img/2gj.jpg"
    }
  })]), _vm._v(" "), _c('Category', {
    attrs: {
      "title": "Forms",
      "icon": "fa fa-navicon",
      "value": "2"
    }
  }, [_c('ListItem', {
    attrs: {
      "title": "带图标",
      "link": "category",
      "img": "https://imgly.net/img/2gj.jpg"
    }
  }), _vm._v(" "), _c('ListItem', {
    attrs: {
      "title": "带图标",
      "link": "category",
      "img": "https://imgly.net/img/2gj.jpg"
    }
  }), _vm._v(" "), _c('ListItem', {
    attrs: {
      "title": "带图标",
      "link": "category",
      "img": "https://imgly.net/img/2gj.jpg"
    }
  })]), _vm._v(" "), _c('Category', {
    attrs: {
      "title": "Forms",
      "img": "https://imgly.net/img/2gj.jpg",
      "value": "1"
    }
  }, [_c('ListItem', {
    attrs: {
      "title": "带图标",
      "link": "category",
      "img": "https://imgly.net/img/2gj.jpg"
    }
  }), _vm._v(" "), _c('ListItem', {
    attrs: {
      "title": "带图标",
      "link": "category",
      "img": "https://imgly.net/img/2gj.jpg"
    }
  }), _vm._v(" "), _c('ListItem', {
    attrs: {
      "title": "带图标",
      "link": "category",
      "img": "https://imgly.net/img/2gj.jpg"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-5456bd1f!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/categoryView.vue
// module id = 244
// module chunks = 0